import { render, staticRenderFns } from "./PollPostDetail.vue?vue&type=template&id=cb9f0e52&scoped=true&"
import script from "./PollPostDetail.vue?vue&type=script&lang=js&"
export * from "./PollPostDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb9f0e52",
  null
  
)

export default component.exports